export const GET_USER_REQUEST = "GET_USER_REQUEST";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_ERROR = "GET_USER_ERROR";
export const getUserRequest = (payload) => ({
  type: GET_USER_REQUEST,
  ...payload,
});
export const getUserSuccess = (user, subcription) => ({
  type: GET_USER_SUCCESS,
  user,
  subcription,
});
export const getUserError = (error) => ({
  type: GET_USER_ERROR,
  error,
});



// WEBPACK FOOTER //
// ./src/pages/admin/actions.js